import apiResponse from "@/models/base/apiResponse";
import { httpClient } from "@/helpers/httpClient";
export default class recommendedReportApi {
    resource = "/api/application/recommendedreports";
    async getRecommendedReports() {
        const response = new apiResponse(async () => await httpClient.get(this.resource));
        await response.ready;
        return response;
    }
}
